import { Component, Input } from "@angular/core";
import { DisputeChangeHistoryBaseDto } from "src/app/shared/models/dispute-resolution/dispute-base-models";

@Component({
  selector: "app-status-changes",
  templateUrl: "./status-changes.component.html",
  styleUrls: ["./status-changes.component.scss"],
  standalone: false,
})
export class StatusChangesComponent {
  @Input() changeHistories: DisputeChangeHistoryBaseDto[] = [];

  get sortedHistories(): DisputeChangeHistoryBaseDto[] {
    return [...(this.changeHistories || [])].sort(
      (a, b) =>
        new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
    );
  }

  isLastHistory(history: DisputeChangeHistoryBaseDto): boolean {
    const arr = this.sortedHistories;
    return arr[arr.length - 1] === history;
  }
}
